import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import Navbar from 'components/Header/Navbar';
import SupportTicketDetail from 'components/support/SupportTicketDetail';
import { supportTicketService } from 'api/services/SupportTicketService';
import type { SupportTicketViewModel } from 'api/types/support-ticket';

const SupportTicketDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { user } = useAuth();
  const navigate = useNavigate();
  const backPath = '/teknik-destek';
  const [ticket, setTicket] = useState<SupportTicketViewModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTicket = useCallback(async (tid: string) => {
    setLoading(true);
    setError(null);
    try {
      const result = await supportTicketService.getMyTicketById(tid);
      if (result.isSuccess && result.data) {
        setTicket(result.data);
      } else {
        setError(result.message ?? 'Talep bulunamadı.');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!user) {
      navigate('/giris', { replace: true });
      return;
    }
    if (id) fetchTicket(id);
    else setError('Talep kodu belirtilmedi.');
  }, [id, user, navigate, fetchTicket]);

  if (!user) return null;

  if (loading) {
    return (
      <div className="min-vh-100 sb-page-bg">
        <Navbar />
        <div className="container py-5 text-center">
          <div className="spinner-border text-primary mb-2" role="status" />
          <p className="text-muted">Talep yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error || !ticket) {
    return (
      <div className="min-vh-100 sb-page-bg">
        <Navbar />
        <div className="container py-5 text-center">
          <p className="text-danger mb-3">{error ?? 'Talep bulunamadı.'}</p>
          <Link className="btn btn-primary" to={backPath}>
            Taleplerime Dön
          </Link>
        </div>
      </div>
    );
  }

  const statusLower = String(ticket.supportStatusName ?? '').toLowerCase();
  const isResolved = statusLower.includes('resolved') ||
    statusLower.includes('çözüldü') ||
    statusLower.includes('kapalı') ||
    statusLower.includes('closed');

  return (
    <div className="min-vh-100 sb-page-bg">
      <Navbar />
      <main className="container py-4">
        <SupportTicketDetail
          ticket={ticket}
          currentUserId={user.id}
          backPath={backPath}
          backLabel="Talep listesine dön"
          isResolved={isResolved}
        />
      </main>
    </div>
  );
};

export default SupportTicketDetailPage;
